import { PublicClientApplication } from '@azure/msal-browser';
import { AuthenticationResult, EventType } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

function setActiveAccount(result?: AuthenticationResult | null): void {
	const account = result?.account ?? msalInstance.getAllAccounts()[0] ?? null;
	if (account) {
		msalInstance.setActiveAccount(account);
	}
}

msalInstance.addEventCallback((event) => {
	if (
		event.eventType === EventType.LOGIN_SUCCESS ||
		event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
		event.eventType === EventType.SSO_SILENT_SUCCESS
	) {
		setActiveAccount(event.payload as AuthenticationResult);
	}
});

export async function initializeMsal(): Promise<void> {
	await msalInstance.initialize();
	let redirectResponse: AuthenticationResult | null = null;
	try {
		redirectResponse = await msalInstance.handleRedirectPromise();
	} catch (error) {
		const message = error instanceof Error ? error.message : String(error);
		// This can happen intermittently when no redirect hash is present anymore.
		if (message.toLowerCase().includes('hash_empty_error')) {
			console.warn('MSAL redirect hash was empty; continuing without redirect result.');
		} else {
			throw error;
		}
	}

	setActiveAccount(redirectResponse);

	if (window.location.hash.includes('code=') || window.location.hash.includes('error=')) {
		window.history.replaceState(null, document.title, `${window.location.pathname}${window.location.search}`);
	}
}
